/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { observer } from 'mobx-react'
import useRootStore from '@store/useRootStore'
import { Modal } from 'antd-mobile'
import { Button, CloseBtn } from '@styles/button.style'
import { LightListDetailPopupWrap, ModalBg } from '@styles/base.style'
import { isMobile } from 'react-device-detect'

const BettingRulesDetail: React.FC = () => {
  const { globalStore, componentStore } = useRootStore()
  const { visibleBettingRulesDetail } = globalStore

  const bettingRule = componentStore.selectedBettingRule

  const doCloseBettingRulesDetail = () => {
    globalStore.setVisibleBettingRulesDetail(false)
  }

  return (
    <Fragment>
      <Modal
        popup
        maskClosable={false}
        visible={visibleBettingRulesDetail}
        animated={false}
        title={
          <Fragment>
            <h1 className="title">상세내용</h1>
            <Button onClick={doCloseBettingRulesDetail} className="close-btn" css={CloseBtn}>
              <span className="close-txt">닫기</span>
            </Button>
          </Fragment>
        }
        className="full-modal message"
        onClose={doCloseBettingRulesDetail}
      >
        <LightListDetailPopupWrap className={!isMobile && 'pc'}>
          {bettingRule && (
            <Fragment>
              <div className="list-info row">
                {bettingRule.isNotice === 1 && (<span className="main-tag">주요</span>)}
                <p className="tit">{bettingRule.title}</p>
              </div>
              <div dangerouslySetInnerHTML={{ __html: bettingRule.content }} className="list-contents"/>
            </Fragment>
          )}
        </LightListDetailPopupWrap>
        <ModalBg onClick={doCloseBettingRulesDetail}/>
      </Modal>
    </Fragment>
  )
}
export default observer(BettingRulesDetail)
